import React from 'react';
import { View } from 'react-native';
import { LottieSizeTokens, LottieTokens, TextAlignTokens, TypographyTypeDLS } from "@voltmoney/schema";
import { Typography } from "../../typography/Typography";
import { Lottie } from "../../lottie/Lottie";
const KycDirect = ({ height }) => {
    // @ts-ignore
    return (React.createElement(View, { style: { justifyContent: 'center', alignContent: 'center', alignItems: 'center', alignSelf: 'center', height: height - 25 } },
        React.createElement(Lottie, { uri: LottieTokens.kyc_loading, size: LottieSizeTokens.Size_140, autoplay: true, loop: true }),
        React.createElement(View, { style: { marginTop: 36 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.H1R, textAlign: TextAlignTokens.center, label: "Hold tight! We are verifying your \n" +
                    "KYC details." }))));
};
export default KycDirect;
